import React, { useMemo } from "react";
import { useTranslation } from 'react-i18next';

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Typography
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useSelector } from "react-redux";

import { selectTotalPrice } from '../../app/features/cartSlice';
import { getTourPricingBreakdown } from '../../utils/checkout';

const ResumenAccordion = () => {

    const { t } = useTranslation(['checkout', 'components']);
    const products = useSelector(state => state.cart.checkout.tours || []);
    const totalPrice = useSelector(selectTotalPrice);

    const productsTotal = useMemo(() => (
        products.map(product => {
            const breakdown = getTourPricingBreakdown(product);
            return {
                name: product.name,
                total: Number(breakdown?.totals?.total) || 0,
            };
        })
    ), [products]);

    const totalIva = useMemo(() => (
        products.reduce((accumulator, product) => {
            const breakdown = getTourPricingBreakdown(product);
            return accumulator + (Number(breakdown?.totals?.iva_total) || 0);
        }, 0)
    ), [products]);
    const subtotalPrice = Math.max((Number(totalPrice) || 0) - (Number(totalIva) || 0), 0);

    return (
        <>
            <Accordion
                sx={{
                    '.Mui-expanded': {
                        minHeight: 'unset!important',
                    },
                    "::before": {
                        backgroundColor: 'unset'
                    },
                    '& .MuiDivider-root': {
                        display: 'none'
                    },
                    boxShadow: 'none',
                    mb: '0!important'
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel-resumen-content`}
                    id={`panel-resumen-header`}
                    sx={{
                        '.Mui-expanded': {
                            my: '0!important',
                        },
                        '& .MuiAccordionSummary-content': {
                            my: 0
                        },
                        minHeight: 'unset',
                        color: 'secondary.main',
                        fontWeight: 'bold',
                        px: 0,
                        borderBottom: '1px solid #223F7F',
                    }}
                >
                    <Typography component="span">
                        {t('purchase-summary')}
                    </Typography>
                </AccordionSummary>
                {productsTotal && productsTotal.map(f => {
                    return (<AccordionDetails
                        key={f.name}
                        sx={{
                            p: '0'
                        }}
                    >
                        <Box
                            sx={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Typography sx=
                                {{
                                    color: 'secondary.main',
                                    fontWeight: 200,
                                    fontSize: '14px'
                                }}
                            >{f.name}</Typography>
                            <Box>
                                <Typography
                                    sx={{
                                        fontSize: '16px',
                                        fontWeight: 500,
                                        color: 'secondary.main'
                                    }}>
                                    {`${f.total}\u20AC`}
                                </Typography>
                            </Box>
                        </Box>
                    </AccordionDetails>)
                })}

            </Accordion>
            <Box sx={{ width: '100%', pt: '10px' }}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', mb: '2px' }}>
                    <Typography sx={{ color: 'secondary.main', fontWeight: 200, fontSize: '14px' }}>Subtotal:</Typography>
                    <Typography sx={{ color: 'secondary.main', fontWeight: 400, fontSize: '14px' }}>
                        {`${subtotalPrice}\u20AC`}
                    </Typography>
                </Box>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', mb: '2px' }}>
                    <Typography sx={{ color: 'secondary.main', fontWeight: 200, fontSize: '14px' }}>IVA:</Typography>
                    <Typography sx={{ color: 'secondary.main', fontWeight: 400, fontSize: '14px' }}>
                        {`${totalIva}\u20AC`}
                    </Typography>
                </Box>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    <Typography sx={{ color: 'secondary.main', fontWeight: 700, fontSize: '14px' }}>Total:</Typography>
                    <Typography sx={{ color: 'secondary.main', fontWeight: 700, fontSize: '16px' }}>
                        {`${totalPrice}\u20AC`}
                    </Typography>
                </Box>
            </Box>
        </>
    )
}

export default ResumenAccordion;
